import styled from '@emotion/styled'
import {
  Grid2 as Grid,
  List,
  ListItemButton as MuiListItemButton,
  ListItemButtonProps as MuiListItemButtonProps,
  ListItemText as MuiListItemText,
} from '@mui/material'

import useT from '@/i18n/useT'
import { TolgeeHelpers } from '@/utils/tolgee.helpers'

interface ListItemButtonProps extends MuiListItemButtonProps {
  href?: string
  target?: string
}

const Wrapper = styled.div`
  padding: ${props => props.theme.spacing(0.25)}
    ${props => props.theme.spacing(4)};
  background: ${props => props.theme.footer.background};
`

const ListItemButton = styled(MuiListItemButton)<ListItemButtonProps>`
  display: inline-block;
  width: auto;
  padding-left: ${props => props.theme.spacing(2)};
  padding-right: ${props => props.theme.spacing(2)};

  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${props => props.theme.footer.color};
  }
`

function Footer() {
  const { t } = useT()

  const daiMarketingWebsite = TolgeeHelpers.sanitizeTranslationForUrls(
    t('websites.daiMarketing'),
  )

  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid
          container
          justifyContent="flex-end"
          size={{
            xs: 12,
          }}
        >
          <List>
            <ListItemButton
              href={daiMarketingWebsite}
              component={'a'}
              rel="noopener noreferrer"
              target="_blank"
            >
              <ListItemText
                primary={t('mainFooter.copyright', {
                  year: new Date().getFullYear(),
                })}
              />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  )
}

export default Footer
